module.exports = __webpack_public_path__ + "img/1_004.4a27f3aa.jpg";